import CardHeader from 'components/card-header';
import List from 'components/list/list';
import React from 'react';
import { useIntl } from 'react-intl';
import { SharedFile } from '../types/shared-folder.type';
import FileRow from './file-row';

type Props = {
  files: SharedFile[];
  isLoading: boolean;
};

const PAGE_NAME_ID = 'fileSharing';

const FileList: React.FC<Props> = ({ files, isLoading }) => {
  const intl = useIntl();

  return (
    <CardHeader label={intl.formatMessage({ id: `${PAGE_NAME_ID}.files` })}>
      <List
        dark
        isLoading={isLoading}
        options={[
          { id: 'file', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.name` }) },
          { id: 'dateCreated', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.list.dateCreated` }) },
          { id: 'actions', label: '', autoWidth: true },
        ]}
        noResult={{
          show: !files?.length,
          text: intl.formatMessage({ id: 'general.noResults' }),
        }}
        orderBy="name">
        {files?.map((file) => (
          <FileRow key={file.id} file={file} />
        ))}
      </List>
    </CardHeader>
  );
};

export default React.memo(FileList);
